import { Injectable } from '@angular/core';
import { matrizFiltroEntity } from '../../../elements/riesgo-credito/entities_riesgos/entities_riesgos';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Loggers } from '../../../util/app-util';
import { MessageService } from '../base/message.service';
import { Service } from '../base/service';

@Injectable({
  providedIn: 'root'
})
export class MatrizFiltroService extends Service<matrizFiltroEntity>{
httpClient: HttpClient;
  constructor(
    http: HttpClient,
    messageService: MessageService,
    protected override logger: Loggers,
    cookiesService: CookieService
  ) { 
    super('concentracion','',http, messageService, logger, cookiesService);
    this.httpClient = http;
  }
  protected getParams(entity: matrizFiltroEntity):HttpParams{
    let params: HttpParams = new HttpParams();
    if (null == entity){return params;}
    if (null != entity.InstitucionId){params = params.set('InstitucionId', entity.InstitucionId)}
    if (null != entity.Periodo){params = params.set('Periodo', entity.Periodo)}
    if (null != entity.PeriodoAnterior){params = params.set('PeriodoAnterior', entity.PeriodoAnterior)}
    if (null != entity.BnIntereses){params = params.set('BnIntereses', entity.BnIntereses.toString())}
    if (null != entity.ZonaId){params = params.set('ZonaId', entity.ZonaId)}
    if (null != entity.ProductoId){params = params.set('ProductoId', entity.ProductoId)}
    if (null != entity.SectorId){params = params.set('SectorId', entity.SectorId)}
    if (null != entity.SucursalId){params = params.set('SucursalId', entity.SucursalId)}
    if (null != entity.AsesorId){params = params.set('AsesorId', entity.AsesorId)}
    return params;
  }
}
